var _g, _path, _path2, _g2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoResultsFavorites = function SvgIconNoResultsFavorites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 172"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Icon_NoResults_Favorites_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C499",
    fillOpacity: 0.5,
    d: "M33.334 29.115A9.115 9.115 0 0 1 42.449 20h75.77a9.115 9.115 0 0 1 9.115 9.115V149.36c0 4.008-4.801 6.064-7.702 3.299l-36.154-34.462a4.557 4.557 0 0 0-6.288 0l-36.154 34.462c-2.901 2.765-7.702.709-7.702-3.299z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_Favorites_svg__b)",
    stroke: "url(#Icon_NoResults_Favorites_svg__c)",
    strokeWidth: 1.75,
    d: "M42.448 20.875h75.772a8.24 8.24 0 0 1 8.239 8.24V149.36c0 3.238-3.879 4.899-6.223 2.665l-36.154-34.462a5.434 5.434 0 0 0-7.496 0l-36.154 34.462c-2.344 2.234-6.223.573-6.223-2.665V29.114a8.24 8.24 0 0 1 8.24-8.239Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Icon_NoResults_Favorites_svg__d",
    width: 94,
    height: 134,
    x: 33,
    y: 20,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004761",
    d: "M33 29.115A9.115 9.115 0 0 1 42.115 20h75.77A9.115 9.115 0 0 1 127 29.115V149.36c0 4.008-4.801 6.064-7.702 3.299l-36.154-34.462a4.557 4.557 0 0 0-6.288 0l-36.154 34.462C37.8 155.424 33 153.368 33 149.36z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Icon_NoResults_Favorites_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_Favorites_svg__e)",
    d: "m26.772 49.166 8.41-43.75 47.735 88.23-49.583-4.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_Favorites_svg__f)",
    d: "m34.791 5.416 68.542 6.563 8.75 70-29.167 11.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_Favorites_svg__g)",
    d: "m31.875 87.813 51.042 5.475-16.75 72.545-34.292-12.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_Favorites_svg__h)",
    d: "m82.789 93.154 44.006-16.279 7.163 87.5-58.333-40.698z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_Favorites_svg__i)",
    d: "m76.354 123.541 33.926 27.222 13.47 54.445-56.875-40.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_Favorites_svg__j)",
    d: "m125.047 24.375 57.037 37.662-70 21.4-4.375-39.374z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M39.749 153c.219-.189 2.764-2.058 2.916-2.334.153-.275.132.095.584-.583.264-.126.378-.954.608-1.127q.345-.26.782-.392t.68-.525q.243-.394.565-.683c.214-.193.672.028.865-.19.192-.217.354-.408.583-.583s.358-.406.584-.583c.225-.178.338-.735.556-.919q.327-.276.723-.473.398-.197.66-.555a1.2 1.2 0 0 1 .735-.459c.314-.067.7.375.825.072.126-.302.187-1.103.518-1.152q.497-.072.833-.344t.51-.736q.173-.465.475-.769.303-.304.75-.448.448-.142.75-.451t.547-.682q.245-.374.63-.59.386-.215.647-.568.259-.352.677-.535.417-.182.77-.433.354-.25.581-.641.228-.39.648-.572t.61-.607q.19-.426.626-.595.437-.168.65-.568t.55-.674q.336-.276.704-.513a1.5 1.5 0 0 0 .556-.666q.187-.426.473-.751a3.5 3.5 0 0 1 .645-.573l.717-.501a4 4 0 0 0 .65-.57 10 10 0 0 1 .613-.608q.322-.291.608-.613a16 16 0 0 0 .556-.663q.27-.342.494-.723a1.6 1.6 0 0 1 .62-.6q.398-.219.675-.553.278-.333.515-.696t.624-.601q.387-.24.591-.634.205-.394.492-.715.286-.32.563-.656t.43-.77c.102-.29.837-.646 1.098-.803.636-.382 3.688-3.092 1.688-.592l-.909 1.2a2 2 0 0 0-.035.612l.059.616q.03.307-.065.61l-.19.607a2.3 2.3 0 0 0-.105.609l-.023.612q-.01.307.022.614l.065.616q.033.308.017.614l-.034.612a4 4 0 0 1-.078.61l-.123.609q-.06.304-.03.047l.061-.516a1.1 1.1 0 0 0-.088-.548l-.237-.582a1.2 1.2 0 0 1-.077-.608l.082-.634q.041-.318-.024-.617l-.13-.6a3.6 3.6 0 0 0-.181-.59l-.235-.582a2.4 2.4 0 0 1-.155-.583l-.074-.584q-.037-.292-.004-.298l.033-.005.086.104-.02-.115m-5.341 5.936-.036.111-.063.562q-.064.563-.209.837l-.29.549a2 2 0 0 0-.2.579l-.11.608a1.5 1.5 0 0 1-.228.569l-.346.531a2.3 2.3 0 0 0-.267.557l-.188.582a2.2 2.2 0 0 0-.109.48l-.028.377q-.015.19-.018.188l-.004-.001.03-.113-.037.111m-1.774-2.424.013.116.175.537q.174.538.155.849l-.037.621q-.018.31.057.61l.15.599q.076.3.028.614l-.095.628a2.3 2.3 0 0 0-.013.618l.07.609q.034.305.076.317l.042.014.072-.09.013.116m.742-7.52-.005.117.092.558q.091.558.026.862l-.13.609a2 2 0 0 0-.035.612l.059.615q.03.308-.065.611l-.19.606a2.3 2.3 0 0 0-.105.609l-.022.613q-.012.305.02.614l.066.615q.033.308.017.614l-.034.612a2.5 2.5 0 0 1-.074.516l-.116.42q-.058.21-.006.213l.052.001.108-.112-.004.116"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.495 21.584a1 1 0 0 0 .012-2l-.006 1zm-.094-1.001-.103.995.048.005h.048zm-1.275.005-.191-.981zm-3.682.05-.033 1zm-2.761-.028-.139-.99zm-2.76-.125-.207-.979zm-6.44-.2-.053-.998zm-1.843.286-.209.978zm-1.84-.04.3.954zm-2.76-.037-.346.938zm-1.84.044-.133.99zm-2.76-.303-.223.975zm-.92.017-.259-.966zm-1.842-.01-.398.916zm-.92-.166-.075-.997zm-2.76.248.519-.855zm-.92-.034.475.88zm-1.845-.097-.259-.966zm-5.998.935-1-.035zm-1.22 1.214-.33-.944zm-2.15.055-.811-.584-.353.49.27.54zm.065-.09.812.584 1.666-2.315-2.747.767zm-.365-.937a1 1 0 0 0 .538 1.927l-.269-.963zm46.936-.787.006-1h-.1l-.006 1-.007 1h.1zm-.1 0 .103-.995c-.58-.06-1.12-.069-1.57.019l.192.981.191.982c.164-.032.474-.045.98.008zm-1.275.005-.191-.981a.66.66 0 0 1-.375-.039l-.354.935-.355.935c.472.18.968.229 1.466.132zm-.92-.085.354-.935a2.3 2.3 0 0 0-1.61-.018l.334.942.334.943a.3.3 0 0 1 .234.003zm-.922-.01-.334-.943c-.207.073-.4.105-.584.105l-.002 1-.003 1a3.7 3.7 0 0 0 1.257-.22zm-.92.162.002-1q-.444 0-.888-.016l-.034 1-.033.999q.476.015.95.017zm-.92-.017.034-.999a4.6 4.6 0 0 0-1.182.117l.226.974.225.974q.337-.077.664-.066zm-.922.092-.226-.974a.7.7 0 0 1-.39-.018l-.304.953-.303.953c.474.15.963.172 1.448.06zm-.92-.039.304-.953a3.06 3.06 0 0 0-1.362-.119l.139.99.138.991c.156-.022.311-.01.478.044zm-.919-.081-.139-.99a8 8 0 0 1-.816.07l.033 1 .033 1a10 10 0 0 0 1.027-.09zm-.922.08-.033-1a1.5 1.5 0 0 1-.557-.089l-.328.945-.328.945q.624.218 1.28.198zm-.918-.144.328-.945a2.7 2.7 0 0 0-1.455-.095l.207.979.206.978a.7.7 0 0 1 .386.028zm-.92-.061-.207-.979q-.4.084-.791.114l.076.997.076.997a8 8 0 0 0 1.052-.15zm-.922.132-.076-.997q-.434.033-.868.043l.024 1 .023 1q.488-.012.973-.049zm-.92.046-.024-1a8 8 0 0 1-.817-.022l-.08.997-.079.996q.511.041 1.023.029zm-.92-.025.079-.997a11 11 0 0 0-1.016-.032l.017 1 .017 1q.412-.007.823.025zm-.92-.029-.017-1a3.4 3.4 0 0 1-.713-.063l-.19.982-.19.982q.561.108 1.127.099zm-.92-.08.19-.983-.917-.177-.191.981-.191.982.92.178zm-.918-.179.191-.981a4.8 4.8 0 0 0-1.164-.082l.053.998.054.999a2.8 2.8 0 0 1 .675.048zm-.92-.065-.053-.998a4 4 0 0 0-1.23.27l.36.932.363.933c.216-.085.42-.128.614-.138zm-.922.204-.362-.932a.6.6 0 0 1-.351.036l-.208.978-.209.978a2.6 2.6 0 0 0 1.492-.127zm-.921.082.208-.978a9 9 0 0 0-1.033-.159l-.094.996-.094.995q.4.039.804.124zm-.919-.141.094-.996a3.3 3.3 0 0 0-1.315.144l.3.954.3.953c.187-.058.36-.075.527-.06zm-.921.102-.3-.954a.3.3 0 0 1-.228-.016l-.392.92-.393.92c.518.22 1.07.254 1.613.083zm-.92-.05.392-.92a2.15 2.15 0 0 0-1.689-.014l.377.926.377.927c.061-.026.09-.025.15 0zm-.92-.008-.377-.926a.24.24 0 0 1-.2.007l-.344.939-.345.938c.545.2 1.11.186 1.643-.031zm-.92.02.344-.94a2.42 2.42 0 0 0-1.55-.05l.286.958.285.958a.43.43 0 0 1 .29.012zm-.92-.032-.285-.959a1.2 1.2 0 0 1-.504.043l-.132.992-.132.99q.68.09 1.338-.108zm-.92.076.131-.992a3.7 3.7 0 0 1-.724-.174l-.327.945-.328.945q.55.191 1.115.267zm-.92-.22.327-.946a2.74 2.74 0 0 0-1.44-.104l.194.981.193.981a.74.74 0 0 1 .398.032zm-.92-.069-.193-.98a1.2 1.2 0 0 1-.505-.01l-.222.976-.223.975c.443.1.892.108 1.337.02zm-.92-.014.222-.975a2.9 2.9 0 0 0-1.4.026l.258.966.258.966a.9.9 0 0 1 .439-.008zm-.92.017-.259-.966a4 4 0 0 1-.733.125l.072.997.07.998q.56-.04 1.108-.188zm-.92.156-.072-.997a.94.94 0 0 1-.452-.087l-.398.917-.398.917c.441.192.91.282 1.39.248zm-.922-.167.398-.917a2.9 2.9 0 0 0-1.393-.245l.076.997.076.997a.9.9 0 0 1 .445.085zm-.92-.165-.075-.997a3.2 3.2 0 0 0-1.33.414l.487.874.486.874c.2-.11.367-.157.509-.168zm-.918.291-.487-.874a.8.8 0 0 1-.413.12l-.021 1-.022 1c.509.011.99-.128 1.429-.372zm-.922.247.022-1a.85.85 0 0 1-.423-.145l-.52.855-.52.854c.432.263.91.424 1.42.435zm-.92-.29.519-.855c-.597-.362-1.28-.4-1.912-.06l.474.88.474.881q.016-.006-.002 0a.2.2 0 0 1-.091-.002q-.009-.004.018.01zm-.92-.034-.473-.88-.02.009.007-.002h.027l.007.001c.002 0-.005 0-.021-.009l-.449.894-.448.894c.601.301 1.253.292 1.845-.026zm-.922.013.449-.894a2.27 2.27 0 0 0-1.631-.182l.259.966.259.966c.046-.012.103-.019.216.038zm-.923-.11-.259-.966a.96.96 0 0 1-.457.014l-.205.978-.204.98a2.96 2.96 0 0 0 1.384-.04zm-.92.026.204-.979a4.7 4.7 0 0 0-1.17-.096l.045 1 .044.998q.33-.015.672.056zm-.92-.076-.045-.999q-.447.02-.894.029l.019 1 .02 1q.472-.01.944-.03zm-.92.03-.02-1-.92.017.017 1 .019 1 .923-.018zm-.923.017-.018-1a5.5 5.5 0 0 0-1.122.137l.222.975.223.975q.356-.081.714-.087zm-.918.112-.222-.975q-.462.105-.93.219l.234.972.235.972q.456-.11.906-.213zm-.918.216-.234-.972a1.6 1.6 0 0 0-.903.562c-.244.31-.33.668-.341.985l1 .035.999.034c0-.014 0 .075-.085.182a.4.4 0 0 1-.2.146zm-.479.61-1-.035q-.001.024-.002.022l.002-.005.01-.018.003-.004q.002 0-.018.014l.581.814.581.814c.524-.374.82-.924.842-1.568zm-.424.788-.581-.814c-.21.15-.39.242-.544.296l.328.944.329.945a4.2 4.2 0 0 0 1.05-.557zm-.797.426-.328-.944.01-.002h.018q.008 0 0-.001l-.04-.017-.46.888-.459.889c.486.25 1.037.323 1.588.132zm-.8-.076.46-.888c-.566-.293-1.175-.282-1.73-.034l.407.913.408.913.034-.012h-.01l-.025-.003q-.01-.004-.003 0zm-.863-.009-.407-.913a4 4 0 0 1-.217.088l.033-.008a.926.926 0 0 1 .454.041c.168.06.404.2.546.484l-.895.448-.894.447c.147.294.393.442.575.507.166.059.31.062.386.06.152-.003.28-.038.347-.057a4 4 0 0 0 .48-.184zm-.486.14.812.584.065-.09-.812-.584-.811-.584-.065.09zm.065-.09-.269-.963-.096.026.269.963.27.964.096-.027z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_Favorites_svg__c",
    x1: 80.334,
    x2: 80.334,
    y1: 20,
    y2: 122.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_Favorites_svg__e",
    x1: 26.042,
    x2: 26.042,
    y1: 5.416,
    y2: 94.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13737A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD5C8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_Favorites_svg__f",
    x1: 34.791,
    x2: 127.157,
    y1: 5.416,
    y2: 76.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DD5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD5C8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_Favorites_svg__g",
    x1: 81.75,
    x2: 37.417,
    y1: 94.083,
    y2: 152.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD4C7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_Favorites_svg__h",
    x1: 105.559,
    x2: 75.449,
    y1: 76.366,
    y2: 210.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DD5C8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_Favorites_svg__i",
    x1: 96.061,
    x2: 65.783,
    y1: 117.996,
    y2: 250.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_Favorites_svg__j",
    x1: 130.14,
    x2: 128.614,
    y1: 0.963,
    y2: 93.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Icon_NoResults_Favorites_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 140 -297.295 0 80.334 20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_NoResults_Favorites_svg__a",
    width: 129,
    height: 168.926,
    x: 15.834,
    y: 2.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_9861_72839",
    stdDeviation: 8.75
  })))));
};
export default SvgIconNoResultsFavorites;